/**
 * Clean CJK (Chinese, Japanese, Korean) spaces
 */
export const cleanCJKSpaces = (value) => {
  return value.replace(
    /([\u3000-\u303f\u3040-\u30ff\u3400-\u4dbf\u4e00-\u9fff\uff00-\uffef])\s+([\u3000-\u303f\u3040-\u30ff\u3400-\u4dbf\u4e00-\u9fff\uff00-\uffef])/g,
    '$1$2'
  );
};

/**
 * Convert base64 to ArrayBuffer
 */
export const base64ToArrayBuffer = (base64) => {
  if (typeof window === 'undefined') {
    return new ArrayBuffer(0);
  }
  let normalized = base64.replace(/-/g, '+').replace(/_/g, '/');
  while (normalized.length % 4 !== 0) {
    normalized += '=';
  }
  const binary = window.atob(normalized);
  const len = binary.length;
  const bytes = new Uint8Array(len);
  for (let i = 0; i < len; i += 1) {
    bytes[i] = binary.charCodeAt(i);
  }
  return bytes.buffer;
};



/**
 * Get avatar URL
 */
export const getAvatarUrl = (avatar) => {
  if (!avatar) return null;
  if (avatar.startsWith('http://') || avatar.startsWith('https://')) {
    return avatar;
  }
  return avatar;
};

/**
 * CN utility for conditional class names
 */
export const cn = (...classes) => {
  return classes.filter(Boolean).join(' ');
};


/**
 * Constructs the WebSocket URL from the base API URL.
 * @param {string} apiBaseUrl - The base URL of the API.
 * @returns {string} The WebSocket URL.
 */
export const getWebSocketUrl = (apiBaseUrl) => {
  if (!apiBaseUrl) {
    // Default fallback if no API base URL is provided
    return 'wss://dev.eshal.ai/knowledge-api/ws';
  }
  try {
    const url = new URL(apiBaseUrl);
    // Replace http/https with ws/wss
    url.protocol = url.protocol.replace(/^http/, 'ws');
    // Append the WebSocket specific path
    url.pathname = '/knowledge-api/ws';
    // Ensure it returns a clean URL without extra slashes
    return url.toString().replace(/\/$/, '');
  } catch (error) {
    console.error("Invalid API base URL provided for WebSocket:", error);
    // Fallback to default if URL parsing fails
    return 'wss://dev.eshal.ai/knowledge-api/ws';
  }
};


/**
 * Check if current domain is allowed
 * @param {string[]} allowedDomains - Array of allowed domains (can include port, e.g., "localhost:3000")
 * @returns {boolean} - True if domain is allowed, false otherwise. Returns false if no domains are specified (mandatory).
 */
export const isDomainAllowed = (allowedDomains = []) => {
  // Check if we're in browser environment
  if (typeof window === 'undefined') {
    return false;
  }

  // Get current hostname and host (host includes port)
  const currentHostname = window.location.hostname.toLowerCase();
  const currentHost = window.location.host.toLowerCase(); // includes port
  
  // Domain is now mandatory - if no domains specified, widget should not load
  if (!allowedDomains || allowedDomains.length === 0) {
    return false;
  }
  
  // Check if current hostname/host matches any allowed domain
  return allowedDomains.some(domain => {
    const normalizedDomain = domain.toLowerCase().trim();
    
    // If domain includes port (e.g., "localhost:3000"), check against host
    if (normalizedDomain.includes(':')) {
      return currentHost === normalizedDomain;
    }
    
    // Otherwise, check against hostname (supports exact match and subdomain match)
    return currentHostname === normalizedDomain || currentHostname.endsWith('.' + normalizedDomain);
  });
};


